import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../API/apiClient";


export const GetSQHistory = createAsyncThunk(
    'History/SQHistory',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('History/GetSQHistory');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  

  export const GetSOHistory = createAsyncThunk(
    'History/SOHistory',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('History/GetSOHistory');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetHistory = createAsyncThunk(
    'History/History',
    async ({docType}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`History/GetHistory?DocType=${docType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetHistoryItems = createAsyncThunk(
    'History/HistoryItems',
    async ({docEntry,docType }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`History/GetHistoryItem?DocEntry=${docEntry}&DocType=${docType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const PrintReport = createAsyncThunk(
    'Printining/PrintReport',
    async ({docEntry,docType }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`PrintReport/ReportData?DocEntry=${docEntry}&DocType=${docType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );